<template>
	<core-loading-button
		:href="url"
		:loading="isLoading"
		@click="createNewCampaign"
		button-class="green button-green create-new-button"
	>
		Create New Campaign
	</core-loading-button>
</template>

<script>
export default {
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		url() {
			return this.$urls.newCampaign();
		},
	},
	methods: {
		createNewCampaign() {
			this.isLoading = true;
			setTimeout(() => {
				this.isLoading = false;
			}, 8000);
		},
	},
};
</script>

<style lang="scss">
.create-new-button {
	margin-left: 10px;
	max-height: 37px;
	position: relative;
	display: inline-block;
	width: auto;

	svg {
		width: 32px;
		height: 32px;
		vertical-align: top;
		transform: translateY(-50%) translateX(-50%);
		top: 50%;
		left: 50%;
		position: absolute;
	}
}
</style>
